module.exports = __webpack_public_path__ + "media/icons/message@3x-76c3f280.svg";